// src/App.js → FINAL PERFECT VERSION (Everything you wanted)

import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Box,
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  Grid,
  Button,
  Stack,
  Fab,
  Chip,
  Divider,
  TextField,
  
} from "@mui/material";
import {
  Menu as MenuIcon,
  Mail,
  Phone,
  WhatsApp,
  ArrowForward,
  ArrowBack,
  LinkedIn,
  CheckCircle as CheckCircleIcon,
  GitHub,
  ArrowUpward,
  Download,
  Code,
  Smartphone,
  School,
  Language,
  FlutterDash,
  ShoppingCart, Apps, Storage, SettingsEthernet, SupportAgent,
} from "@mui/icons-material";
import { motion, AnimatePresence } from "framer-motion";


// Rotating title in hero
const RotatingTitle = () => {
  const titles = ["Flutter Developer", "Mobile Engineer", "Full-Stack Dev", "AI Enthusiast", "Networking"];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setIndex((i) => (i + 1) % titles.length), 3000);
    return () => clearInterval(id);
  }, []);
  
  return (
    <Box sx={{ minHeight: 70, mt: 2 }}>
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -30, opacity: 0 }}
          transition={{ duration: 0.6 }}
          style={{
            fontSize: "clamp(1.8rem, 5vw, 2.8rem)",
            fontWeight: 800,
            background: "linear-gradient(90deg, #30309ae3, #2e155fff)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent",
          }}
        >
          {titles[index]}
        </motion.div>
      </AnimatePresence>
    </Box>
  );
};



export default function App() {
  const [mobileMenu, setMobileMenu] = useState(null);
  const open = Boolean(mobileMenu);
  

 const scrollTo = (id, tab = null) => {
  // Scroll to section
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
  
  // If it's Projects, also switch to Projects tab
  if (tab === "projects") {
    setActiveTab("projects");
  }
  
  setMobileMenu(null);
};
  const handleDownloadCV = () => {
    const link = document.createElement("a");
    link.href = "images/THANDOKUHLE SIBANDZE CURRICULUM VITAE.pdf";
    link.download = "Thandokuhle_Sibandze_CV.pdf";
    link.click();
  };
  const [activeTab, setActiveTab] = useState("skills");

  const projects = [
  {
    title: "Cinema Booking Application",
    desc: "Final year project featuring movie listings, user authentication, seat booking, and payment integration.",
    tech: "Flutter • Firebase",
    live: "https://example.com",
    code: "https://github.com",
  },
  {
    title: "AI Traffic Sign Recognition",
    desc: "Built a deep learning model to recognize traffic signs using computer vision.",
    tech: "Python • TensorFlow • OpenCV",
    live: "https://example.com",
    code: "https://github.com",
  },
  {
    title: "E-commerce Platform",
    desc: "Full-stack e-commerce system with cart, payments, and admin dashboard.",
    tech: "PHP • MySQL • Bootstrap",
    live: "https://example.com",
    code: "https://github.com",
  },
  {
    title: "JAKERNA FAST FOOD",
    desc: "Online food ordering system with real-time tracking.",
    tech: "React • Node.js • MySQL",
    live: "https://www.jaekernafood.co.za",
  },
  {
    title: "JAEKERNA IT SERVICE",
    desc: "IT support platform for individuals and businesses.",
    tech: "React • Firebase • Firestore",
    live: "https://www.jaekerna.online",
  },
];


  return (
    <>
      

     {/* Navigation – Fully Mobile Responsive with Hamburger */}
<AppBar
  position="fixed"
  sx={{
    bgcolor: "rgba(255, 255, 255, 0.96)",
    backdropFilter: "blur(12px)",
    boxShadow: 1,
    zIndex: 1000,
  }}
>
  <Container maxWidth="lg">
    <Toolbar sx={{ py: { xs: 1.5, md: 2 }, minHeight: { xs: 64, md: "auto" } }}>
      {/* Desktop: Pill Menu */}
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          justifyContent: "center",
          flexGrow: 1,
          gap: 2,
          bgcolor: "rgba(53, 53, 255, 0.1)",
         // backgroundImage: `url('/images/Thandokuhle.jpg')`,//"linear-gradient(90deg, rgba(202, 42, 42, 0.8), rgba(255, 255, 255, 0.6))",
          px: 4,
          py: 1,
          borderRadius: 50,
        }}
      >
        {["Home", "About", "Skills", "Education", "Projects", "Contact"].map((item) => {
  const isProjects = item === "Projects";
  return (
    <Button
      key={item}
      onClick={() => scrollTo(isProjects ? "skills" : item.toLowerCase(), isProjects ? "projects" : null)}
      sx={{ color: "#1b2562ff", fontWeight: 600, textTransform: "none" }}
    >
      {item}
    </Button>
  );
})}
      </Box>

      {/* Mobile: Hamburger Icon */}
      <IconButton
        onClick={(e) => setMobileMenu(e.currentTarget)}
        sx={{
          display: { xs: "flex", md: "none" },
          ml: "auto",
          color: "#30309ae3",
        }}
      >
        <MenuIcon sx={{ fontSize: 32 }} />
      </IconButton>
    </Toolbar>
  </Container>

  {/* Mobile Menu Drawer */}
  <Menu
    anchorEl={mobileMenu}
    open={Boolean(mobileMenu)}
    onClose={() => setMobileMenu(null)}
    PaperProps={{
      sx: {
        width: "100%",
        maxWidth: "100vw",
        mt: 1,
        borderRadius: 3,
        boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
      },
    }}
    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    transformOrigin={{ vertical: "top", horizontal: "right" }}
  >
    {["Home", "About", "Skills", "Education", "Projects", "Contact"].map((item) => {
  const isProjects = item === "Projects";
  return (
    <MenuItem
      key={item}
      onClick={() => {
        scrollTo(isProjects ? "skills" : item.toLowerCase(), isProjects ? "projects" : null);
        setMobileMenu(null);
      }}
      sx={{ fontSize: "1.1rem", fontWeight: 600, py: 2, justifyContent: "center" }}
    >
      {item}
    </MenuItem>
  );
})}
  </Menu>
</AppBar>
{/* 
// Add this import at the top with other imports
import { ArrowBack } from "@mui/icons-material";

// Add this Floating Back Button - PASTE RIGHT AFTER AppBar closing tag (around line 120) */}
<Fab
  size="medium"
  sx={{
    position: "fixed",
    top: { xs: 80, md: 24 },  // Higher on desktop, lower on mobile
    left: { xs: 16, md: 24 },
    zIndex: 1300,
    bgcolor: "rgba(255, 255, 255, 0.95)",
    color: "#30309A",
    boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
    backdropFilter: "blur(10px)",
    "&:hover": {
      bgcolor: "#ffffff",
      transform: "translateY(-2px)",
      boxShadow: "0 12px 35px rgba(0,0,0,0.2)",
    },
    transition: "all 0.3s ease",
  }}
  onClick={() => {
    // Go back to parent HTML site
    window.location.href = "../index.html";
    // OR if same folder: window.location.href = "index.html";
    // OR full URL: window.location.href = "https://yourmain-site.com";
  }}
>
  <ArrowBack />
</Fab>


      {/* <Menu anchorEl={mobileMenu} open={open} onClose={() => setMobileMenu(null)}>
        {["Home", "About", "Skills", "Education", "Projects", "Contact"].map((item) => (
          <MenuItem key={item} onClick={() => scrollTo(item.toLowerCase())}>{item}</MenuItem>
        ))}
      </Menu> */}

      {/* HERO – Text LEFT, Photo RIGHT */}
      <Box id="home" sx={{ minHeight: "100vh", display: "flex", alignItems: "center", pt: 16 }}>
        <Container maxWidth="lg">
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <motion.div initial={{ opacity: 0, x: -60 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
                <Typography sx={{ color: "#000000ff", fontWeight: 700, fontSize: "1.2rem", letterSpacing: "3px" }}>HELLO</Typography>
                <Typography variant="h1" sx={{ fontSize: { xs: "2.8rem", md: "4.2rem" }, fontWeight: 900, lineHeight: 1.1 }}>
                  I'm <span style={{ background: "linear-gradient(90deg, #30309A, #ff6b35)", WebkitBackgroundClip: "text", color: "transparent" }}>Thandokuhle</span>
                </Typography>
                <RotatingTitle />
                <Stack direction={{ xs: "column", sm: "row" }} spacing={3} sx={{ mt: 6 }}>
                  <Button variant="contained" onClick={() => scrollTo("contact")} sx={{ bgcolor: "#30309A", borderRadius: 50, px: 6, py: 3, fontSize: "1.1rem", "&:hover": { bgcolor: "#2b41e5ff" } }}>Hire Me</Button>
                  <Button variant="outlined" startIcon={<Download />} onClick={handleDownloadCV} sx={{ borderColor: "#30309A", color: "#30309A", borderRadius: 50, px: 6, py: 3, "&:hover": { bgcolor: "#30309A", color: "white" } }}>Download CV</Button>
                </Stack>
              </motion.div>
            </Grid>
            <Grid item xs={12} md={6}>
              <motion.div initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.9 }}>
                <Box sx={{ position: "relative", display: "inline-block" }}>
                  <Box sx={{ position: "absolute", top: -16, right: -16, width: "100%", height: "100%", border: "6px solid #ff6b35", borderRadius: "24px"  }} />
                  <Avatar src="images/Thandokuhle.jpg" sx={{ width: { xs: 300, md: 440 }, height: { xs: 360, md: 520 }, borderRadius: "20px", border: "10px solid white", boxShadow: 10 }} />
                </Box>
              </motion.div>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* ABOUT – Photo LEFT, Text RIGHT */}
      {/* ABOUT – PHOTO LEFT, TEXT RIGHT – PERFECT ALIGNMENT */}
{/* ABOUT – PHOTO LEFT, TEXT RIGHT */}
<Box id="about" sx={{ py: { xs: 12, md: 24 }, bgcolor: "#fafafa" }}>
  <Container maxWidth="lg">
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "stretch",
        gap: { xs: 6, md: 10 },
      }}
    >
      {/* PHOTO LEFT */}
      <Box
        sx={{
          flex: { xs: "1 1 auto", md: "0 0 45%" },
          display: { xs: "none", md: "flex" },
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <motion.div
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Box sx={{ position: "relative" }}>
            <Box
              sx={{
                position: "absolute",
                top: -24,
                left: -24,
                width: "100%",
                height: "100%",
                border: "8px solid #ff6b35",
                borderRadius: "32px",
                zIndex: 1,
              }}
            />
            <Avatar
              src="images/Thandokuhle.jpg"
              alt="Thandokuhle"
              sx={{
                width: { xs: 280, sm: 340, md: 420 },
                height: { xs: 360, sm: 420, md: 520 },
                borderRadius: "28px",
                border: "14px solid white",
                boxShadow: "0 30px 80px rgba(0,0,0,0.3)",
                position: "relative",
                zIndex: 2,
              }}
            />
            
            <Stack
              spacing={2}
              sx={{
                position: "absolute",
                top: "30%",
                left: -90,
                display: { xs: "none", md: "flex" },
              }}
            >
              <IconButton sx={{ bgcolor: "#30309ae3", color: "white" }}>
                <LinkedIn />
              </IconButton>
              <IconButton sx={{ bgcolor: "#ff6b35", color: "white" }}>
                <GitHub />
              </IconButton>
              <IconButton sx={{ bgcolor: "#30309ae3", color: "white" }}>
                <Mail />
              </IconButton>
            </Stack>
          </Box>
        </motion.div>
      </Box>

      {/* TEXT RIGHT */}
      <Box
        sx={{
          flex: { xs: "1 1 auto", md: "0 0 55%" },
          display: "flex",
          alignItems: "center",
        }}
      >
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          {/* <Typography
            sx={{
              color: "#30309ae3",
              fontWeight: 700,
              fontSize: "1.4rem",
              letterSpacing: "4px",
            }}
          >
            HELLO
          </Typography> */}
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: "2.4rem", md: "3rem" },
              fontWeight: 900,
              mb: 3,
              lineHeight: 1.1,
            }}
          >
            Thandokuhle Sibandze
          </Typography>
          <Typography
            sx={{
              fontSize: "1.1rem",
              color: "#000000ff",
              lineHeight: 1.9,
              mb: 5,
            }}
          >
             Software Developer who specializing in high-performance mobile and web applications 
             using Flutter, React, and modern cloud technologies. Committed to delivering scalable, 
             production-ready solutions with clean, efficient code.
          </Typography>

          <Grid container spacing={4}>
            <Grid item xs={12} sm={6}>
              <Typography color="#000000ff">Name</Typography>
              <Typography fontWeight="bold" sx={{ fontSize: "1.05rem" }}>
                Thandokuhle Sibandze
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography color="#202020ff">Email</Typography>
              <Typography fontWeight="bold">
                thandokuhlesibandze@gmail.com
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography color="#202020ff">Phone</Typography>
              <Typography fontWeight="bold">+268 7622 7393</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography color="#202020ff">Location</Typography>
              <Typography fontWeight="bold">Mbabane, Eswatini</Typography>
            </Grid>
          </Grid>
        </motion.div>
      </Box>
    </Box>
  </Container>
</Box>


 {/* SKILLS & PROJECTS — MOBILE SAFE, NO CUTOFF */}
<Box id="skills" sx={{ py: { xs: 12, md: 20 }, bgcolor: "#ffffff" }}>
  <Container maxWidth="lg">

    {/* Title */}
    <Typography
      variant="h3"
      align="center"
      sx={{
        fontSize: { xs: "2.6rem", md: "3.8rem" },
        fontWeight: 900,
        mb: 10,
        background: "linear-gradient(90deg, #30309ae3, #ff6b35)",
        WebkitBackgroundClip: "text",
        backgroundClip: "text",
        color: "transparent",
      }}
    >
      Skills & Projects
    </Typography>

    {/* Tab Switcher */}
    <Box sx={{ display: "flex", justifyContent: "center", mb: 10 }}>
      <Box
        sx={{
          bgcolor: "#f1f5f9",
          borderRadius: 50,
          p: 1,
          display: "inline-flex",
          boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
        }}
      >
        {["Skills", "Projects"].map((tab) => (
          <Button
            key={tab}
            onClick={() => setActiveTab(tab.toLowerCase())}
            sx={{
              minWidth: 160,
              py: 2,
              borderRadius: 50,
              fontWeight: 700,
              fontSize: "1.1rem",
              textTransform: "none",
              color: activeTab === tab.toLowerCase() ? "white" : "#64748b",
              bgcolor: activeTab === tab.toLowerCase() ? "#30309ae3" : "transparent",
              "&:hover": {
                bgcolor: activeTab === tab.toLowerCase()
                  ? "#30309ae3"
                  : "#e2e8f0",
              },
              transition: "all 0.3s ease",
            }}
          >
            {tab}
          </Button>
        ))}
      </Box>
    </Box>

    {/* CONTENT CONTAINER — AUTO HEIGHT */}
    <Box sx={{ width: "100%", position: "relative" }}>
      <AnimatePresence mode="wait">

        {/* ================= SKILLS ================= */}
        {activeTab === "skills" && (
          <motion.div
            key="skills"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35 }}
          >
            <Grid container spacing={{ xs: 3, sm: 4, md: 4 }}>
              {[
                { icon: <img src="/images/icons8-flutter-logo-48.png" alt="Flutter" style={{ width: 48, height: 48 }} />, name: "Flutter", level: 95 },
                { icon: <img src="/images/science.png" alt="Flutter" style={{ width: 48, height: 48 }} />, name: "React", level: 88 },
                { icon: <img src="/images/html.png" alt="Flutter" style={{ width: 48, height: 48 }} />, name: "Html", level: 92 },
                { icon: <img src="/images/icons8-css3-48.png" alt="Flutter" style={{ width: 48, height: 48 }} />, name: "Css", level: 85 },
                { icon: <img src="/images/java-script.png" alt="Flutter" style={{ width: 48, height: 48 }} />, name: "Java", level: 90 },
                { icon: <img src="/images/python.png" alt="Flutter" style={{ width: 48, height: 48 }} />, name: "Python", level: 82 },
                { icon: <img src="/images/icons8-c-programming-48.png" alt="Flutter" style={{ width: 48, height: 48 }} />, name: "C", level: 95 },
                { icon: <img src="/images/icons8-sql-48.png" alt="Flutter" style={{ width: 48, height: 48 }} />, name: "MySql", level: 95 },
                { icon: <img src="/images/icons8-firebase-48.png" alt="Flutter" style={{ width: 48, height: 48 }} />, name: "Firebase", level: 95 },
              ].map((skill) => (
                <Grid item xs={6} sm={6} md={4} key={skill.name}>
                  <motion.div whileHover={{ y: -6 }} transition={{ duration: 0.3 }}>
                    <Box
                      sx={{
                        bgcolor: "#ffffff",
                        p: { xs: 2.5, sm: 3, md: 4 },
                        borderRadius: 5,
                        textAlign: "center",
                        boxShadow: "0 15px 40px rgba(53, 53, 255, 0.12)",
                        border: "2px solid #fefefeff",
                        transition: "all 0.4s",
                        display: "flex",
                        flexDirection: "column",
                        width: "125px",
                        height: "125px",
                        justifyContent: "space-between",
                        minHeight: { xs: 180, sm: 220, md: 260 },
                        "&:hover": {
                          borderColor: "#30309ae3",
                          transform: "translateY(-10px)",
                          boxShadow: "0 25px 50px rgba(0,0,0,0.15)",
                        },
                      }}
                    >
                      <Box>
                        <Box sx={{ color: "#30309ae3", mb: 1.5 }}>
                          {skill.icon}
                        </Box>
                        <Typography
                          variant="h6"
                          fontWeight={800}
                          sx={{
                            fontSize: { xs: "1rem", sm: "1.1rem", md: "1.3rem" },
                            lineHeight: 1.2,
                          }}
                        >
                          {skill.name}
                        </Typography>
                      </Box>

                      <Box>
                        <Box
                          sx={{
                            bgcolor: "#e5e7eb",
                            borderRadius: 10,
                            height: 10,
                            overflow: "hidden",
                            mt: 1.5,
                          }}
                        >
                          <motion.div
                            initial={{ width: 0 }}
                            whileInView={{ width: `${skill.level}%` }}
                            viewport={{ once: true }}
                            transition={{ duration: 1.5, ease: "easeOut" }}
                            style={{
                              height: "100%",
                              background:
                                "linear-gradient(90deg, #30309ae3, #4f46e5)",
                              borderRadius: 10,
                            }}
                          />
                        </Box>

                        <Typography
                          sx={{
                            mt: 1,
                            color: "#30309ae3",
                            fontWeight: 700,
                            fontSize: { xs: "0.95rem", md: "1rem" },
                          }}
                        >
                          {skill.level}%
                        </Typography>
                      </Box>
                    </Box>
                  </motion.div>
                </Grid>
              ))}
            </Grid>
          </motion.div>
        )}

        {/* ================= PROJECTS ================= */}
        {activeTab === "projects" && (
          <motion.div
            key="projects"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35 }}
          >
            <Box
              sx={{
                overflowX: "auto",
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": { display: "none" },
                py: 4,
                px: { xs: 1, md: 2 },
                mx: { xs: -2, md: -4 },
                width: { xs: "calc(100% + 32px)", md: "calc(100% + 64px)" },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: 3, md: 4 },
                  width: "fit-content",
                  pl: { xs: 2, md: 4 },
                }}
              >
                {projects.map((project, i) => (
                  <Box
                    key={`${project.title}-${i}`}
                    sx={{
                      flex: "0 0 320px",
                      minHeight: 340,
                      bgcolor: "#fff",
                      borderRadius: 5,
                      p: { xs: 3, md: 4 },
                      boxShadow: "0 20px 40px rgba(0,0,0,0.12)",
                      transition: "all 0.4s",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      "&:hover": {
                        boxShadow: "0 30px 60px rgba(48, 48, 155, 0.2)",
                        transform: "translateY(-8px)",
                      },
                    }}
                  >
                    <Box>
                      <Typography variant="h6" fontWeight={900} sx={{ mb: 1 }}>
                        {project.title}
                      </Typography>
                      <Typography sx={{ color: "#555", mb: 1.5 }}>
                        {project.desc}
                      </Typography>
                      <Typography sx={{ color: "#30309ae3", fontWeight: 700 }}>
                        {project.tech}
                      </Typography>
                    </Box>

                    
                    {/* 🔥 LIVE & CODE BUTTONS RESTORED */}
                    <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
                      {project.live && (
                        <Button
                          variant="contained"
                          size="small"
                          href={project.live}
                          target="_blank"
                          sx={{
                            bgcolor: "#30309ae3",
                            borderRadius: 50,
                            px: 2.5,
                            fontSize: "0.7rem",
                            "&:hover": { bgcolor: "#2563eb" },
                          }}
                        >
                          Live
                        </Button>
                      )}

                      {project.code && (
                        <Button
                          variant="outlined"
                          size="small"
                          startIcon={<GitHub sx={{ fontSize: 14 }} />}
                          href={project.code}
                          target="_blank"
                          sx={{
                            borderColor: "#30309ae3",
                            color: "#30309ae3",
                            borderRadius: 50,
                            fontSize: "0.7rem",
                            px: 2,
                            "&:hover": {
                              bgcolor: "#f0f7ff",
                              borderColor: "#30309ae3",
                            },
                          }}
                        >
                          Code
                        </Button>
                      )}
                    </Stack>
                  
                  </Box>
                ))}
              </Box>
            </Box>

            <Typography align="center" color="text.secondary">
              Swipe or scroll to explore projects
            </Typography>
          </motion.div>
        )}

      </AnimatePresence>
    </Box>

    {/* Spacer */}
    <Box sx={{ height: { xs: 60, md: 80 } }} />

  </Container>
</Box>



  {/* SERVICES SECTION – PIXEL-PERFECT MATCH TO YOUR WASTIX PHOTO */}
  <Box sx={{ py: { xs: 10, md: 16 }, bgcolor: '#f9fafb' }}>
  <Container maxWidth="lg">
  {/* Title exactly like the photo */}
  <Typography
  variant="h3"
  align="center"
 sx={{
        fontSize: { xs: "2.6rem", md: "3.8rem" },
        fontWeight: 900,
        mb: 10,
        background: "linear-gradient(90deg, #30309ae3, #ff6b35)",
        WebkitBackgroundClip: "text",
        backgroundClip: "text",
        color: "transparent",
      }}
  >
  Services I Offer
  </Typography>

{/* Cards Grid – 3 per row on all screens, fixed size like photo */}
<Grid container spacing={4} justifyContent="center">
  {[
    { title: "Website Design & Development", desc: "Modern, responsive websites built with React, Next.js, or Flutter Web. Includes hosting, domain setup, SEO, and maintenance.", icon: <Code sx={{ fontSize: 56, color: '#10b981' }} /> },
    { title: "E-Commerce Solutions", desc: "Full online stores with secure payments, inventory tracking, and user-friendly shopping experience.", icon: <ShoppingCart sx={{ fontSize: 56, color: '#10b981' }} /> },
    { title: "Custom System Development", desc: "Bespoke mobile apps and web systems designed for your unique business needs.", icon: <Apps sx={{ fontSize: 56, color: '#10b981' }} /> },
    { title: "Database Design & Modeling", desc: "Expert database implementation (MySQL, Firebase, MongoDB), optimization, and secure data management.", icon: <Storage sx={{ fontSize: 56, color: '#10b981' }} /> },
    { title: "Networking & System Installation", desc: "Complete IT infrastructure: network setup, server configuration, hardware installation, and cybersecurity.", icon: <SettingsEthernet sx={{ fontSize: 56, color: '#10b981' }} /> },
    { title: "Support & Maintenance", desc: "Ongoing technical support, updates, backups, and performance monitoring.", icon: <SupportAgent sx={{ fontSize: 56, color: '#10b981' }} /> },
  ].map((service) => (
    <Grid item xs={12} md={4} key={service.title}>
      <Box
        sx={{
          bgcolor: 'white',
          borderRadius: 5,
          p: 4,
          height: 300,                    // EXACT height from your photo
          width: '100%',                  // Full width of grid item
          maxWidth: 400,                  // Max width constraint like photo
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
          boxShadow: '0 8px 30px rgba(0,0,0,0.07)',
          transition: 'all 0.3s ease',
          mx: 'auto',                     // Center cards
          '&:hover': { transform: 'translateY(-6px)', boxShadow: '0 20px 40px rgba(0,0,0,0.1)' },
        }}
      >
        {/* Icon – same size and color as Wastix */}
        {service.icon}

        {/* Title */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: 800,
            color: '#1e293b',
            mt: 3,
            mb: 2,
            fontSize: '1.25rem',
          }}
        >
          {service.title}
        </Typography>

        {/* Description – auto cuts like in the photo */}
        <Typography
          sx={{
            color: '#64748b',
            fontSize: '0.95rem',
            lineHeight: 1.6,
            textAlign: 'center',
            flexGrow: 1,
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {service.desc}
        </Typography>

      </Box>
    </Grid>
  ))}
</Grid>
</Container> </Box>
{/* 


<Box id="pricing" sx={{ py: { xs: 12, md: 20 }, bgcolor: "#ffffff" }}>
  <Container maxWidth="lg">
    
    <Typography
      variant="h3"
      align="center"
      sx={{
        fontSize: { xs: "2.6rem", md: "3.8rem" },
        fontWeight: 900,
        mb: 10,
        background: "linear-gradient(90deg, #30309ae3, #30309ae3)",
        WebkitBackgroundClip: "text",
        backgroundClip: "text",
        color: "transparent",
      }}
    >
      Pricing Packages
    </Typography>

    <Typography align="center" sx={{ mb: 12, fontSize: "1.2rem", color: "#64748b", maxWidth: 800, mx: "auto" }}>
      Transparent pricing tailored to your needs. All packages include revisions, clean code, documentation, and 1-month free support.
      Custom quotes available for larger projects.
    </Typography>

    
    <Grid container spacing={6} justifyContent="center">
      {[
        {
          title: "Basic",
          price: "R8,000 - R15,000",
          desc: "Perfect for startups & personal sites",
          features: [
            "Static or Simple Dynamic Website",
            "Up to 5 Pages",
            "Responsive Design",
            "Basic SEO Setup",
            "Contact Form",
            "1 Week Delivery",
          ],
          popular: false,
        },
        {
          title: "Professional",
          price: "R20,000 - R40,000",
          desc: "Most popular for businesses",
          features: [
            "Custom Web Application or E-Commerce",
            "Up to 15 Pages/Features",
            "Admin Dashboard",
            "Payment Integration",
            "Advanced SEO",
            "Database Setup",
            "2-4 Weeks Delivery",
          ],
          popular: true,
        },
        {
          title: "Enterprise",
          price: "R50,000+",
          desc: "Full custom systems & ongoing support",
          features: [
            "Complex Systems (ERP, CRM, etc.)",
            "Unlimited Pages/Features",
            "Mobile App Integration",
            "API Development",
            "Networking & Installation",
            "Training & Maintenance Plan",
            "Custom Timeline",
          ],
          popular: false,
        },
      ].map((tier, i) => (
        <Grid item xs={12} md={4} key={i}>
          <motion.div whileHover={{ y: -12 }} transition={{ duration: 0.4 }}>
            <Box
              sx={{
                height: "100%",
                bgcolor: "#ffffff",
                borderRadius: 5,
                p: 5,
                textAlign: "center",
                boxShadow: "0 15px 40px rgba(0,0,0,0.1)",
                border: tier.popular ? "3px solid #30309ae3" : "2px solid transparent",
                position: "relative",
                overflow: "hidden",
                transition: "all 0.4s",
                "&:hover": {
                  boxShadow: "0 30px 60px rgba(48,48,155,0.2)",
                },
              }}
            >
              {tier.popular && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bgcolor: "#30309ae3",
                    color: "white",
                    py: 1,
                    fontWeight: 700,
                    fontSize: "0.9rem",
                  }}
                >
                  MOST POPULAR
                </Box>
              )}

              <Typography variant="h4" fontWeight={900} sx={{ mt: tier.popular ? 6 : 0, mb: 2 }}>
                {tier.title}
              </Typography>

              <Typography variant="h3" fontWeight={900} sx={{ mb: 2, color: "#30309ae3" }}>
                {tier.price}
              </Typography>

              <Typography sx={{ mb: 4, color: "#64748b" }}>{tier.desc}</Typography>

              <Divider sx={{ my: 4 }} />

              <Stack spacing={2} alignItems="flex-start" sx={{ textAlign: "left" }}>
                {tier.features.map((feature, idx) => (
                  <Box key={idx} sx={{ display: "flex", alignItems: "center" }}>
                    <CheckCircleIcon sx={{ color: "#30309ae3", mr: 2, fontSize: 20 }} />
                    <Typography>{feature}</Typography>
                  </Box>
                ))}
              </Stack>

              <Button
                variant={tier.popular ? "contained" : "outlined"}
                size="large"
                fullWidth
                sx={{
                  mt: 6,
                  py: 2,
                  borderRadius: 50,
                  bgcolor: tier.popular ? "#30309ae3" : "transparent",
                  borderColor: "#30309ae3",
                  color: tier.popular ? "white" : "#30309ae3",
                  "&:hover": {
                    bgcolor: tier.popular ? "#30309ae3" : "#f0f7ff",
                  },
                }}
              >
                Get Started
              </Button>
            </Box>
          </motion.div>
        </Grid>
      ))}
    </Grid>

    <Typography align="center" sx={{ mt: 10, color: "#64748b" }}>
      Prices are estimates in ZAR • Final quote based on project scope • 50% deposit required
    </Typography>
  </Container>
</Box>
           
             */}
      {/* EDUCATION SECTION — BEAUTIFUL TIMELINE STYLE */}

      <Box id="education" sx={{ py: { xs: 14, md: 22 }, bgcolor: "#0f172a", color: "#e2e8f0" }}>
        <Container maxWidth="lg">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <Typography
              variant="h3"
              align="center"
              sx={{
                fontSize: { xs: "2.8rem", md: "4rem" },
                fontWeight: 900,
                mb: 12,
                background: "linear-gradient(90deg, #ff6b35, #f7931e)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              Education
            </Typography>
          </motion.div>

          <Grid container spacing={8} alignItems="center">
            {/* Timeline Line */}
            <Grid item xs={12} md={1}>
              <Box
                sx={{
                  width: 6,
                  height: "100%",
                  bgcolor: "#ff6b35",
                  borderRadius: 3,
                  mx: "auto",
                  position: "relative",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: -10,
                    width: 26,
                    height: 26,
                    borderRadius: "50%",
                    bgcolor: "#ff6b35",
                    border: "8px solid #1e293b",
                  },
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    bottom: 0,
                    left: -10,
                    width: 26,
                    height: 26,
                    borderRadius: "50%",
                    bgcolor: "#ff6b35",
                    border: "8px solid #1e293b",
                  },
                }}
              />
            </Grid>

            {/* Education Items */}
            <Grid item xs={12} md={11}>
              <Stack spacing={10}>
                {[
                  {
                    degree: "Bachelor of Science in Computer Science",
                    school: "Eswatini Medical Christian University (EMCU)",
                    year: "2021 – 2025, Expected Graduation: 2026",
                    grade: "Current GPA: 3.4",
                    desc: "Specializing in Android Programming, Artificial Intelligence, Database Systems, Software Engineering, Networking, Web Development, Information Systems, Project Management.",
                  },
                  {
                    degree: "High School Diploma (IGCSE)",
                    school: "Evelyn Baring High School",
                    year: "2017 — 2018",
                  },
                ].map((edu, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: index % 2 === 0 ? -80 : 80 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: index * 0.3 }}
                  >
                    <Box
                      sx={{
                        bgcolor: "#1e293b",
                        p: { xs: 5, md: 7 },
                        borderRadius: 5,
                        border: "2px solid transparent",
                        backgroundImage: "linear-gradient(#1e293b, #1e293b), linear-gradient(90deg, #ff6b35, #f7931e)",
                        backgroundOrigin: "border-box",
                        backgroundClip: "padding-box, border-box",
                        boxShadow: "0 20px 40px rgba(0,0,0,0.4)",
                        position: "relative",
                        ml: { md: index % 2 === 0 ? 0 : 8 },
                        mr: { md: index % 2 === 0 ? 8 : 0 },
                        "&::before": {
                          content: '""',
                          position: "absolute",
                          top: "50%",
                          left: index % 2 === 0 ? -28 : "auto",
                          right: index % 2 === 0 ? "auto" : -28,
                          width: 40,
                          height: 40,
                          bgcolor: "#ff6b35",
                          borderRadius: "50%",
                          transform: "translateY(-50%)",
                          border: "8px solid #0f172a",
                          zIndex: 2,
                        },
                      }}
                    >
                      <Typography
                        variant="h4"
                        sx={{
                          fontSize: { xs: "1.6rem", md: "2.1rem" },
                          fontWeight: 900,
                          background: "linear-gradient(90deg, #ff6b35, #f7931e)",
                          WebkitBackgroundClip: "text",
                          color: "transparent",
                          mb: 2,
                        }}
                      >
                        {edu.degree}
                      </Typography>
                      <Typography variant="h6" sx={{ fontWeight: 700, opacity: 0.9, mb: 1 }}>
                        {edu.school}
                      </Typography>
                      <Typography sx={{ color: "#ff6b35", fontWeight: 600, mb: 2 }}>
                        {edu.year}
                      </Typography>
                      <Typography sx={{ fontWeight: 600, color: "#94a3b8", mb: 2 }}>
                        {edu.grade}
                      </Typography>
                      <Typography sx={{ lineHeight: 1.8, opacity: 0.85 }}>
                        {edu.desc}
                      </Typography>
                    </Box>
                  </motion.div>
                ))}
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </Box>


      

{/* CONTACT SECTION — RESPONSIVE & NO OVERLAP */}
<Box id="contact" sx={{ py: { xs: 12, md: 20 }, bgcolor: "#ffffff" }}>
  <Container maxWidth="lg">
    {/* Header */}
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
    >
      <Typography
        variant="h3"
        align="center"
        sx={{
          fontSize: { xs: "2.4rem", md: "3.8rem" },
          fontWeight: 900,
          mb: 3,
          background: "linear-gradient(90deg, #ff6b35, #f7931e)",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          color: "transparent",
        }}
      >
        Get In Touch
      </Typography>
      <Typography
        align="center"
        sx={{
          fontSize: { xs: "1rem", md: "1.2rem" },
          color: "#666",
          mb: { xs: 6, md: 8 },
          maxWidth: 680,
          mx: "auto",
        }}
      >
        I'm currently open to new opportunities. Whether you have a project or just want to say hi, my inbox is always open!
      </Typography>
    </motion.div>

    {/* Form + Info - STACKED FORM FIELDS */}
    <Grid container spacing={6} sx={{ alignItems: "stretch" } } justifyContent={"center"} padding={1}>
      {/* ---------- LET'S CONNECT (LEFT SIDE) ---------- */}
      <Grid item xs={12} md={5}  padding left={10} marginRight={10} >
        <motion.div
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Box sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", py: 4 }}>
            <Typography
              variant="h4"
              sx={{ fontWeight: 900, mb: { xs: 4, md: 5 }, color: "#1e293b" }}
            >
              Let's Connect
            </Typography>

            <Stack spacing={4} sx={{ mb: 5 }}>
              {/* Email */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <IconButton sx={{ bgcolor: "#ff6b35", color: "white", width: 50, height: 50 }}>
                  <Mail />
                </IconButton>
                <Box>
                  <Typography sx={{ fontWeight: 600, color: "#444", fontSize: "0.95rem" }}>
                    Email
                  </Typography>
                  <Typography sx={{ fontSize: "1rem", fontWeight: 700 }}>
                    <a href="mailto:thandokuhlesibandze@gmail.com" style={{ textDecoration: 'none', color: 'inherit' }}>
                      thandokuhlesibandze@gmail.com
                    </a>
                  </Typography>
                </Box>
              </Box>

              {/* Phone */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <IconButton sx={{ bgcolor: "#ff6b35", color: "white", width: 50, height: 50 }}>
                  <Phone />
                </IconButton>
                <Box>
                  <Typography sx={{ fontWeight: 600, color: "#444", fontSize: "0.95rem" }}>
                    Phone
                  </Typography>
                  <Typography sx={{ fontSize: "1rem", fontWeight: 700 }}>
                    +268 7622 7393
                  </Typography>
                </Box>
              </Box>

              {/* WhatsApp */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <IconButton sx={{ bgcolor: "#ff6b35", color: "white", width: 50, height: 50 }}>
                  <WhatsApp />
                </IconButton>
                <Box>
                  <Typography sx={{ fontWeight: 600, color: "#444", fontSize: "0.95rem" }}>
                    WhatsApp
                  </Typography>
                  <Typography sx={{ fontSize: "1rem", fontWeight: 700 }}>
                    <a 
                      href="https://wa.me/26876227393?text=Hi!%20I%20found%20your%20portfolio%20and%20want%20to%20connect."
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                      Chat on WhatsApp
                    </a>
                  </Typography>
                </Box>
              </Box>
            </Stack>

            {/* Social */}
            <Box>
              <Typography sx={{ fontWeight: 700, mb: 3, fontSize: "1.2rem", color: "#1e293b" }}>
                Follow Me
              </Typography>
              <Stack direction="row" spacing={2}>
                <IconButton
                  sx={{
                    bgcolor: "#ff6b35",
                    color: "white",
                    width: 56,
                    height: 56,
                    "&:hover": { bgcolor: "#e55a2b", transform: "scale(1.1)" },
                    transition: "all 0.3s",
                  }}
                  onClick={() => window.open("https://linkedin.com/in/yourprofile", "_blank")}
                >
                  <LinkedIn sx={{ fontSize: 30 }} />
                </IconButton>
                <IconButton
                  sx={{
                    bgcolor: "#ff6b35",
                    color: "white",
                    width: 56,
                    height: 56,
                    "&:hover": { bgcolor: "#e55a2b", transform: "scale(1.1)" },
                    transition: "all 0.3s",
                  }}
                  onClick={() => window.open("https://github.com/yourusername", "_blank")}
                >
                  <GitHub sx={{ fontSize: 30 }} />
                </IconButton>
              </Stack>
            </Box>
          </Box>
        </motion.div>
      </Grid>

      {/* ---------- FORM (RIGHT SIDE) - STACKED FIELDS ---------- */}
      <Grid item xs={12} md={7}>
        <motion.div
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Box
            component="form" 
            onSubmit={(e) => {
              e.preventDefault();
              const form = e.target;
              const data = new FormData(form);
              const name = data.get("name");
              const email = data.get("email");
              const message = data.get("message");

              window.location.href = `mailto:thandokuhlesibandze@gmail.com?subject=Portfolio%20Contact%20from%20${encodeURIComponent(
                name
              )}&body=${encodeURIComponent(message)}%0A%0AReply%20to:%20${encodeURIComponent(email)}`;

              form.reset();
            }}
            sx={{
              bgcolor: "#f8f9fa",
              p: 6,
              borderRadius: 4,
              boxShadow: "0 20px 50px rgba(255,107,53,0.12)",
              border: "2px solid #fff1ed",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: 3,
            }}
          >
            {/* Name Field */}
            <TextField
              required
              fullWidth
              name="name"
              label="Your Name"
              variant="outlined"
              InputProps={{ style: { borderRadius: 8 } }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#ff6b35" },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#ff6b35" },
                },
                "& .MuiInputLabel-root.Mui-focused": { color: "#ff6b35" },
              }}
            />

            {/* Email Field */}
            <TextField
              required
              fullWidth
              name="email"
              type="email"
              label="Your Email"
              variant="outlined"
              InputProps={{ style: { borderRadius: 8 } }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#ff6b35" },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#ff6b35" },
                },
                "& .MuiInputLabel-root.Mui-focused": { color: "#ff6b35" },
              }}
            />

            {/* Message Field */}
            <TextField
              required
              fullWidth
              name="message"
              label="Your Message"
              multiline
              rows={5}
              variant="outlined"
              InputProps={{ style: { borderRadius: 8 } }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#ff6b35" },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#ff6b35" },
                },
                "& .MuiInputLabel-root.Mui-focused": { color: "#ff6b35" },
              }}
            />

            {/* Submit Button */}
            <Button
              type="submit"
              variant="contained"
              size="large"
              sx={{
                bgcolor: "#ff6b35",
                color: "white",
                py: 2.2,
                px: 6,
                borderRadius: 50,
                fontSize: "1.2rem",
                fontWeight: 800,
                boxShadow: "0 12px 30px rgba(255,107,53,0.35)",
                "&:hover": {
                  bgcolor: "#e55a2b",
                  transform: "translateY(-2px)",
                  boxShadow: "0 16px 36px rgba(255,107,53,0.45)",
                },
                transition: "all 0.3s",
              }}
            >
              Send Message
            </Button>
          </Box>
        </motion.div>
      </Grid>
    </Grid>
  {/* Bottom spacing before footer */}
    <Box sx={{ height: { xs: 60, md: 80 } }} />
  </Container>
</Box>



      {/* Scroll to Top */}
      <Fab onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} sx={{ position: "fixed", bottom: 40, right: 40, bgcolor: "#ff6b35", "&:hover": { bgcolor: "#e55a2b" } }}>
        <ArrowUpward />
      </Fab>


     {/* COOL ANIMATED FOOTER */}
<Box sx={{ 
  bgcolor: "#0f172a", 
  color: "#e2e8f0", 
  py: { xs: 8, md: 10 }, 
  textAlign: "center",
  position: "relative",
  overflow: "hidden"
}}>
  {/* Animated Background Elements */}
  <motion.div
    initial={{ scale: 0, rotate: 180 }}
    animate={{ 
      scale: 1, 
      rotate: 0 
    }}
    transition={{ 
      duration: 1.2, 
      ease: "easeOut" 
    }}
    style={{
      position: "absolute",
      top: "-20%",
      right: "-20%",
      width: "200px",
      height: "200px",
      background: "radial-gradient(circle, rgba(255,107,53,0.1) 0%, transparent 70%)",
      borderRadius: "50%",
      zIndex: 1
    }}
  />
  
  <motion.div
    initial={{ scale: 0, rotate: -180 }}
    animate={{ 
      scale: 1, 
      rotate: 0 
    }}
    transition={{ 
      duration: 1.5, 
      delay: 0.3,
      ease: "easeOut" 
    }}
    style={{
      position: "absolute",
      bottom: "-15%",
      left: "-15%",
      width: "250px",
      height: "250px",
      background: "radial-gradient(circle, rgba(48,48,154,0.08) 0%, transparent 70%)",
      borderRadius: "50%",
      zIndex: 1
    }}
  />

  {/* Main Content */}
  <Container maxWidth="lg">
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
    >
      <Stack spacing={3} alignItems="center">
        {/* Logo/Name with Pulse */}
        <motion.div
          animate={{ 
            scale: [1, 1.05, 1],
            opacity: [0.8, 1, 0.8]
          }}
          transition={{ 
            duration: 3, 
            repeat: Infinity,
            ease: "easeInOut"
          }}
        >
          <Typography 
            variant="h4" 
            sx={{ 
              fontWeight: 900,
              background: "linear-gradient(90deg, #ff6b35, #f7931e)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent"
            }}
          >
            Thandokuhle Sibandze
          </Typography>
        </motion.div>

        {/* Copyright */}
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <Typography 
            variant="h6" 
            sx={{ 
              fontWeight: 400,
              opacity: 0.8,
              fontSize: { xs: "1rem", md: "1.2rem" }
            }}
          >
            © 2026 Thandokuhle Sibandze. All rights reserved.
          </Typography>
        </motion.div>

        {/* Social Links - Float Up */}
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <Stack direction="row" spacing={2}>
            <IconButton 
              sx={{ 
                bgcolor: "rgba(255,255,255,0.1)", 
                color: "white",
                "&:hover": { bgcolor: "#ff6b35" }
              }}
              size="small"
            >
              <LinkedIn />
            </IconButton>
            <IconButton 
              sx={{ 
                bgcolor: "rgba(255,255,255,0.1)", 
                color: "white",
                "&:hover": { bgcolor: "#ff6b35" }
              }}
              size="small"
            >
              <GitHub />
            </IconButton>
          </Stack>
        </motion.div>
      </Stack>
    </motion.div>
  </Container>
</Box>

    </>
  );
}